<template>
	<div>
		<!-- タイトル -->
		<PageTitle title-name="お知らせ管理" />
		<VmBox>
			<template #content>
				<v-data-table
					:headers="headers"
					:items="announcementArray"
					:search="search"
					multi-sort
					class="elevation-1 overflow-y-auto"
					disable-pagination
					no-data-text="お知らせがありません"
					hide-default-footer
					:loading="isLoading"
					fixed-header
					:height="announcementArray.length > 15 ? 48 * 15 - 1 : undefined"
				>
					<template v-slot:top>
						<v-dialog v-model="showAddDialog" max-width="800px">
							<template v-slot:activator="{ on, attrs }">
								<VmButton text="新規お知らせ" type="primary" v-bind="attrs" v-on="on" @click="openAddDialog" />
							</template>
							<AdminAnnouncementFormCard
								@closeAction="closeAdd"
								@addAction="add"
								:editedItem="editedItem"
								formTitle="お知らせ追加"
								:loading="isLoading"
							/>
						</v-dialog>
						<v-dialog v-model="dialog" max-width="800px">
							<AdminAnnouncementFormCard
								@closeAction="close"
								@addAction="save"
								:editedItem="editedItem"
								formTitle="お知らせ編集"
								buttonTitle="edit"
								:loading="isLoading"
							/>
						</v-dialog>
						<v-dialog v-model="dialogDelete" max-width="500px">
							<AdminDeleteFormCard
								@closeDeleteAction="closeDelete"
								@deleteItemConfirmAction="deleteItemConfirm"
								formTitle="このお知らせを削除しますか？"
							/>
						</v-dialog>
						<v-text-field v-model="search" label="検索" class="filter-item"></v-text-field>
					</template>

					<template v-slot:[`item.title`]="{ item }">
						<span>
							{{ limitedText30(item.title) }}
						</span>
					</template>

					<template v-slot:[`item.content`]="{ item }">
						<span>{{ limitedText50(item.content) }}</span>
					</template>

					<template v-slot:[`item.targetStudent`]="{ item }">
						<span v-if="item.targetStudentName">
							{{ item.targetStudentName }}
						</span>
						<span v-else class="grey--text">対象者なし</span>
					</template>

					<template v-slot:[`item.createdAt`]="{ item }">
						<span>{{ formatDateTime(item.createdAt) }}</span>
					</template>

					<template v-slot:[`item.edit`]="{ item }">
						<v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
					</template>
					<template v-slot:[`item.delete`]="{ item }">
						<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
					</template>
				</v-data-table>
			</template>
		</VmBox>
	</div>
</template>

<script>
import AdminDeleteFormCard from '../Organisms/AdminDeleteFormCard'
import PageTitle from '../Atoms/PageTitle'
import VmBox from '../Atoms/VmBox'
import AdminAnnouncementFormCard from '../Organisms/AdminAnnouncementFormCard'
import { mapGetters, mapActions } from 'vuex'
import { limitedText30, limitedText50 } from '../../util/limitText'
import VmButton from '../Atoms/VmButton'

export default {
	name: 'AdminAnnouncement',
	components: {
		AdminDeleteFormCard,
		PageTitle,
		VmBox,
		AdminAnnouncementFormCard,
		VmButton
	},
	data: () => ({
		announcementArray: [],
		search: '',
		dialog: false,
		showAddDialog: false,
		dialogDelete: false,
		selectedAnnouncementId: 0,
		isLoading: false,
		editedItem: {
			id: null,
			title: '',
			content: '',
			targetStudent: null
		}
	}),
	computed: {
		...mapGetters({
			userInfo: 'user/getUserInfo',
			announcements: 'adminAnnouncement/announcements',
			students: 'adminStudent/students'
		}),
		headers() {
			return [
				{ text: 'Actions', value: 'edit', align: 'start', sortable: false, width: 80 },
				{ text: 'ID', value: 'id', width: 80 },
				{ text: '対象者', value: 'targetStudent', width: 120 },
				{ text: 'タイトル', value: 'title', width: 200 },
				{ text: '内容', value: 'content', width: 250 },
				{ text: '作成日時', value: 'createdAt', width: 150 },
				{ text: 'Actions', value: 'delete', sortable: false, width: 80 }
			]
		},
		totalUnreadCount() {
			return this.announcementArray.reduce((sum, item) => sum + (item.unreadCount || 0), 0)
		},
		activeAnnouncementCount() {
			return this.announcementArray.filter((item) => item.isActive).length
		}
	},
	async created() {
		await this.fetchInitialData()
		await this.reloadTable()
	},
	methods: {
		...mapActions({
			fetchAdminAnnouncements: 'adminAnnouncement/fetchAnnouncements',
			createAnnouncement: 'adminAnnouncement/createAnnouncement',
			updateAnnouncement: 'adminAnnouncement/updateAnnouncement',
			deleteAnnouncement: 'adminAnnouncement/deleteAnnouncement',
			fetchAllStudents: 'adminStudent/fetchAllStudents'
		}),
		async reloadTable() {
			this.isLoading = true
			console.log('reloadTable開始')
			try {
				console.log('fetchAdminAnnouncements呼び出し前')
				await this.fetchAdminAnnouncements({
					accessToken: this.accessToken
				})
				console.log('fetchAdminAnnouncements完了後')
				console.log('Vuexストア状態確認:', this.$store.state.adminAnnouncement)
				this.makeAnnouncementArray()
			} catch (error) {
				console.error('お知らせの取得に失敗しました:', error)
			} finally {
				this.isLoading = false
			}
		},
		async fetchInitialData() {
			const user_info = this.$store.getters['user/getUserInfo']
			this.accessToken = user_info.accessToken

			// 全生徒を取得
			try {
				await this.fetchAllStudents(this.accessToken)
			} catch (error) {
				console.error('生徒一覧の取得に失敗しました:', error)
			}
		},
		makeAnnouncementArray() {
			// Vuexストアからデータを直接取得（既に正規化済み）
			const announcements = this.$store.getters['adminAnnouncement/announcements'] || []
			console.log('Vuexストアからの取得データ: ', announcements)
			console.log('this.announcements: ', this.announcements)

			// 実際の生徒データから名前を取得
			const getStudentName = (studentId) => {
				if (!studentId || !this.students) return null
				const student = this.students.find((s) => s.id === studentId)
				return student ? student.name : `生徒ID: ${studentId}`
			}

			this.announcementArray = announcements.map((announcement) => ({
				id: announcement.id,
				title: announcement.title,
				content: announcement.content,
				targetStudent: announcement.targetStudent,
				targetStudentName: getStudentName(announcement.targetStudent),
				createdAt: announcement.createdAt,
				updatedAt: announcement.updatedAt
			}))
			console.log('作成されたannouncementArray: ', this.announcementArray)
		},
		editItem(item) {
			this.selectedAnnouncementId = item.id
			this.editedItem = {
				id: item.id,
				title: item.title,
				content: item.content,
				targetStudent: item.targetStudent
			}
			this.dialog = true
		},
		resetEditedForm() {
			this.editedItem = {
				id: null,
				title: '',
				content: '',
				targetStudent: null
			}
		},
		deleteItem(item) {
			this.selectedAnnouncementId = item.id
			this.editedItem = { ...item }
			this.dialogDelete = true
		},
		async deleteItemConfirm() {
			try {
				await this.deleteAnnouncement({
					announcementId: this.selectedAnnouncementId,
					accessToken: this.accessToken
				})
				this.closeDelete()
				await this.reloadTable()
			} catch (error) {
				alert('削除に失敗しました: ' + error.message)
			}
		},
		close() {
			this.dialog = false
			this.$nextTick(() => {
				this.resetEditedForm()
			})
		},
		closeAdd() {
			this.showAddDialog = false
			this.$nextTick(() => {
				this.resetEditedForm()
			})
		},
		closeDelete() {
			this.dialogDelete = false
			this.$nextTick(() => {
				this.resetEditedForm()
			})
		},
		async save() {
			try {
				await this.updateAnnouncement({
					announcement: this.editedItem,
					accessToken: this.accessToken
				})
				this.close()
				await this.reloadTable()
			} catch (error) {
				alert('更新に失敗しました: ' + error.message)
			}
		},
		async add() {
			try {
				await this.createAnnouncement({
					announcement: this.editedItem,
					accessToken: this.accessToken
				})
				this.closeAdd()
				await this.reloadTable()
			} catch (error) {
				alert('作成に失敗しました: ' + error.message)
			}
		},
		openAddDialog() {
			this.resetEditedForm()
			this.showAddDialog = true
		},
		formatDateTime(dateString) {
			if (!dateString) return ''
			const date = new Date(dateString)
			return date.toLocaleString('ja-JP', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit'
			})
		},
		// テキスト制限関数
		limitedText30,
		limitedText50
	}
}
</script>

<style lang="scss" scoped>
.filter-item {
	padding: 10px 5px;
}

.announcement-stats {
	margin-bottom: 20px;
}

.v-data-table {
	white-space: nowrap;
}

.overflow-y-auto {
	overflow-y: auto;
}
</style>
